import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDisableFormat = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.8 13.55L12.45 8.2H24.6V11.2H18.8L17.8 13.55ZM24.4 25.8L16.1 17.5L14.1 22.2H10.825L13.8 15.2L6 7.4L7.4 6L25.8 24.4L24.4 25.8Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDisableFormat);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
